// extracted by mini-css-extract-plugin
module.exports = {"Content":"Footer_Content__3J0SA"};